import { createFileRoute } from "@tanstack/react-router";
import { AvatarForm } from "@/components/onboarding/avatar-form";
import { OnboardingLayout } from "@/components/onboarding/onboarding-layout";

export const Route = createFileRoute("/onboarding/avatar")({
	component: OnboardingStep2,
});

function OnboardingStep2() {
	return (
		<OnboardingLayout>
			<AvatarForm />
		</OnboardingLayout>
	);
}
